var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTuneMob(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_380_1982",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_380_1982)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4583 21.875V15.625H13.5417V17.7083H21.875V19.7917H13.5417V21.875H11.4583ZM3.125 19.7917V17.7083H9.375V19.7917H3.125ZM7.29167 15.625V13.5417H3.125V11.4583H7.29167V9.375H9.375V15.625H7.29167ZM11.4583 13.5417V11.4583H21.875V13.5417H11.4583ZM15.625 9.375V3.125H17.7083V5.20833H21.875V7.29167H17.7083V9.375H15.625ZM3.125 7.29167V5.20833H13.5417V7.29167H3.125Z",
    fill: "#A0A0A3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTuneMob);
export default __webpack_public_path__ + "static/media/tune_mob.62c16198e06f68943f913835a3fb923b.svg";
export { ForwardRef as ReactComponent };